module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M2.006 8.024C.903 8.024 0 8.947 0 10.074v11.992c0 1.127.903 2.006 2.006 2.006h2.006v6.676c0 1.131 1.065 1.663 1.809.881l6.776-7.557h5.456a1.997 1.997 0 0 0 2.006-2.006V10.074c0-1.127-.903-2.05-2.006-2.05H2.005zM14.042 0c-1.103 0-2.006.923-2.006 2.05v3.968h8.024c1.109 0 2.006.899 2.006 2.006v10.889l4.209 4.692c.744.78 1.809.251 1.809-.881v-6.676h2.006a1.997 1.997 0 0 0 2.006-2.006V2.05C32.096.923 31.193 0 30.09 0H14.042z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/chat-3.js
// module id = 1056
// module chunks = 14